import { Injectable } from '@angular/core';
import { SqlAdapterService, SqlStatement } from 'src/app/common/sharedServices/sql/sql-adapter.service';
import { Evento } from 'src/app/common/models/Evento';

@Injectable({
  providedIn: 'root'
})
export class EventiSqlAdapterService {
  private readonly SCHEMA = `(
    aziCdazi VARCHAR(3) NOT NULL,
    idIntervento INTEGER NOT NULL,
    idEvento INTEGER NOT NULL,

    oggetto TEXT NOT NULL,
    CONSTRAINT pk_interventi PRIMARY KEY (aziCdazi, idIntervento, idEvento)

  );`;

  constructor(private sql: SqlAdapterService) {
    this.initTable();
  }

  private async initTable() {
    const query = `CREATE TABLE IF NOT EXISTS Eventi ${this.SCHEMA}`;
    try {
      const created = await this.sql.execute({
        statement: query,
      });
      console.log('Created table Eventi ? ', created);
    } catch (error) {
      console.error('Errore while creating table Eventi', error);
    }
  }

  async inserisciEventi(Eventi: Evento[]) {
    const insertQueries = Eventi.map(this.getSingleInsertQuery);
    try {
      const inserted = await this.sql.executeSet(insertQueries);
      console.log('Inserted into table Eventi ? ', inserted);
    } catch (error) {
      console.error('Errore while inserting data into table Eventi', error);
    }
  }

  private getSingleInsertQuery(evento: Evento): SqlStatement {
    const query = `INSERT INTO Eventi (aziCdazi, idIntervento, idEvento, oggetto) VALUES (?, ?, ?, ?)`;
    return {
      statement: query,
      values: [
        evento.aziCdazi, evento.idIntervento, evento.idEvento, JSON.stringify(evento)]
    };
  }


  /**
   * Prova ad aggiornare l'intervento fornito salvato eventualmente sul DB per
   * mantenere i dati consistenti
   * Può fallire
   * @param intervento 
   */
  async updateEvento(evento: Evento) {
    const query = `UPDATE Eventi SET oggetto = ? WHERE (idIntervento = ? AND idEvento = ? AND aziCdazi = ? ;`;
    try {
      const updated = await this.sql.execute({
        statement: query,
        values: [JSON.stringify(evento), evento.idIntervento, evento.idEvento, evento.aziCdazi]
      });
      console.log('Update existing evento  ? ', updated);
    } catch (error) {
      console.error('Errore while updating data from table Eventi', error);
    }
  }

  /**
   * Rimuove tutti gli Eventi presenti a DB
   */
  async rimuoviEventi() {
    const query = `DELETE FROM Eventi ;`;
    try {
      const removed = await this.sql.execute({
        statement: query
      });
      console.log('Removed all Eventi ? ', removed);
    } catch (error) {
      console.error('Errore while removing from table Eventi', error);
    }
  }

  async fetchEventiOffline(idIntervento: number): Promise<Evento[]> {
    const selectField = `SELECT idIntervento, oggetto FROM Eventi WHERE (idIntervento = ? ); `;
    try {
      const records = await this.sql.execute({
        statement: selectField,
        values: [idIntervento]
      });

      const result = [];
      for (let k = 0; k < records.values.length; k++) {
        result.push(records.values[k]);
      }
      console.debug('Select eventi result', result);
      return result.map(row => JSON.parse(row.oggetto));
    } catch (error) {
      console.error('Errore while selecting data from table Eventi', error);
      return [];
    }
  }
}